// src/mqttService.js
import mqtt from 'mqtt'
import { useBalanceStore } from '@/stores/balance.js'
import mitt from 'mitt'

const emitter = mitt()

const client = mqtt.connect({
  protocol: 'wss',
  host: import.meta.env.VITE_URL_MQTT_HOST,
  port: 443,
  path: '/mqtt',
  username: import.meta.env.VITE_URL_MQTT_USER,
  password: import.meta.env.VITE_URL_MQTT_PASS,
  reconnectPeriod: 1000,
  connectTimeout: 4000,
  clean: true
})

client.on('connect', () => {
  console.log('✅ MQTT connected')
})
client.on('offline', () => {
  console.warn('⚠️ MQTT offline')
})

client.on('connect', () => {
  console.log('Connected to MQTT broker')
  const userId = useBalanceStore().user?.id?.toString(25)
  if (userId) {
    client.subscribe(`topic/profile/${userId}`)
  }
})

client.on('message', (topic, message) => {
  const msgString = message.toString()
  let payload
  try {
    payload = JSON.parse(msgString)
  } catch (e) {
    return console.error('Invalid MQTT JSON:', msgString)
  }

  if (topic.startsWith('topic/profile/') && payload.message != null) {
    const balanceStore = useBalanceStore()
    balanceStore.resetBalanceFetched()
    balanceStore.fetchBalance()
  }

  emitter.emit(topic, payload)
})

client.on('error', (err) => {
  console.error('MQTT connection error:', err)
  client.end()
})

export function subscribeFixture(matchId, handler) {
  const topic = `feeds/live/odds_change/${matchId}`
  client.subscribe(topic, (err) => {
    if (err) console.error('Sub to', topic, 'failed:', err)
    else console.log('Subscribed to', topic)
  })
  emitter.on(topic, handler)
}

export function unsubscribeFixture(matchId, handler) {
  const topic = `feeds/live/odds_change/${matchId}`
  client.unsubscribe(topic, (err) => {
    if (err) console.error('Unsub from', topic, 'failed:', err)
  })
  emitter.off(topic, handler)
}

export default client
